"use strict";

exports.__esModule = true;
exports.compose = compose;

var _parser = require("./parser");

function compose(...parsers) {
  let config = {};
  parsers.forEach(parser => {
    if (!parser || !parser.config) {
      return;
    }

    config = { ...config,
      ...parser.config
    };
  });
  const parser = (0, _parser.createParser)(config);
  return parser;
}